import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";
import { Item } from "../customer/customerApi";
import { IPhone } from "../relatives/relativesApi";
import { IHobby } from "../selectOptions/selectOptionsApi";
export interface IBusiness {
  id: number
  taxCode: string
  businessName: string
  email: string
  phoneBusiness: IPhone[]
  foundingDate: string
  address: string
  businessField: Item
  businessRelationship: Item
  province: Item
  district: Item

}

export interface IBusiness_V2 {
  id: number
  taxCode: string
  businessName: string
  email: string[]
  phoneBusiness: IPhone[]
  foundingDate: string
  address: string
  profession: Item
  businessRelationship: Item
  province: Item
  district: Item

}

export interface IBusinessCustomers {
  id: number
  username: string
  gender: number
  CCCD: string
  birthday: string
  email: string
  address: string
  profession: Item
  phoneBusiness: string
  province: Item
  district: Item
}
export interface IListBusinessCustomers {
  id: number
  username: string
  gender: number
  CCCD: string
  birthday: string
  email: string
  address: string
  profession: string
  phoneBusiness: string
  provinceId: number
  provinceTitle: string
  districtId: number
  districtTitle: string
}
//	Danh sách doanh nghiệp của khách hàng
export const getListBusiness = async (
  customerId: number
) => {
  const path = "business/listBusiness"
  const params = {
    customerId
  }
  const result: ResponseSuccess<IBusiness[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Thông tin doanh nghiệp của khách hàng
export const getInfoBusiness = async (
  customerId?: number, taxCode?: string
) => {
  const path = "business/infoBusiness"
  const params = {
    customerId, taxCode
  }
  const result: ResponseSuccess<IBusiness> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin doanh nghiệp của khách hàng
export const getInfoBusiness_V2 = async (
  customerId?: number, taxCode?: string
) => {
  const path = "business/infoBusiness"
  const params = {
    customerId, taxCode
  }
  const result: ResponseSuccess<IBusiness_V2> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin Thông tin khách hàng củadoanh nghiệp
export const getInfoCustomer = async (
  customerId?: number, CCCD?: string
) => {
  const path = "business/infoCustomer"
  const params = {
    customerId, CCCD
  }
  const result: ResponseSuccess<IBusinessCustomers> = await axiosClient.get(
    path, { params }
  );
  return result;
};



//Thêm mới doanh nghiệp thành công
export const addBusiness = async (
  customerId: number, taxCode: string, businessName: string, businessRelationshipId: number, email: string = "",
  phone: string, foundingDate: string, businessFieldId: number, provinceId: number, districtId: number, address?: string, unitTempId?: number
) => {
  const url = "business/addBusiness";
  const params = {
    customerId, taxCode, businessName, businessRelationshipId, email,
    phone, foundingDate, businessFieldId, provinceId, districtId, address, unitTempId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Thêm mới doanh nghiệp thành công
export const addBusiness_V3 = async (
  customerId: number, taxCode: string, businessName: string, phone: IPhone[],
  businessRelationshipId?: number, email?: string, foundingDate?: string,
  professionId?: number, provinceId?: number, districtId?: number,
  address?: string, unitTempId?: number
) => {
  const url = "business/addBusiness";
  const params = {
    customerId, taxCode, businessName, phone,
    businessRelationshipId, email, foundingDate,
    professionId, provinceId, districtId,
    address, unitTempId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Thêm mới doanh nghiệp thành công
export const addBusiness_V4 = async (
  customerId: number, taxCode: string, businessName: string, phone: IPhone[],
  professionId?: number, email?: string[], businessRelationshipId?: number, unitTempId?: number
) => {
  const url = "business/addBusiness";
  const params = {
    customerId, taxCode, businessName, phone,
    professionId, email, businessRelationshipId, unitTempId

  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa doanh nghiệp
export const editBusiness = async (
  id: number, businessRelationshipId: number, email: string, phone: string, foundingDate: string,
  professionId: number, provinceId: number, districtId: number, address: string

) => {
  const url = "business/editBusiness";
  const params = {
    id, businessRelationshipId, email, phone, foundingDate,
    professionId, provinceId, districtId, address
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa khác hàng doanh nghiệp
export const editBusiness_V3 = async (
  id: number, phone: IPhone[],
  businessRelationshipId?: number, email?: string, foundingDate?: string,
  professionId?: number, provinceId?: number, districtId?: number, address?: string
) => {
  const url = "business/editBusiness";
  const params = {
    id, phone,
    businessRelationshipId, email, foundingDate,
    professionId, provinceId, districtId, address
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}
//Chỉnh sửa khác hàng doanh nghiệp
export const editBusiness_V4 = async (
  id: number, phone: IPhone[], customerId: number,
  businessRelationshipId?: number, email?: string,
  professionId?: number, address?: string[]
) => {
  const url = "business/editBusiness";
  const params = {
    id, phone, customerId,
    businessRelationshipId, email,
    professionId, address
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}
//Xóa doanh nghiệp
export const deleteBusiness = async (
  businessId: number, customerId: number
) => {
  const url = "business/deleteBusiness";
  const params = {
    businessId, customerId
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}


//dùng cho thêm dn
//Thêm mới khách hàng thành công
export const addCustomer = async (
  businessId: number, username: string, CCCD: string, gender: number, birthday: string,
  email: string, phone: string, provinceId: number, districtId: number, professionId: number, address: string
) => {
  const url = "business/addCustomer";
  const params = {
    businessId, username, CCCD, gender, birthday,
    email, phone, provinceId, districtId, professionId, address
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa khách hàng doanh nghiệp
export const editCustomer = async (
  id: number, username: string, CCCD: string, gender: number, birthday: string,
  email: string, phone: string, provinceId: number, districtId: number, professionId: number, address: string
) => {
  const url = "business/editCustomer";
  const params = {
    id, username, CCCD, gender, birthday,
    email, phone, provinceId, districtId, professionId, address
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa khách hàng doanh nghiệp
export const deleteCustomer = async (
  businessId: number, customerId: number
) => {
  const url = "business/deleteCustomer";
  const params = {
    businessId, customerId
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}
